import { render, staticRenderFns } from "./Demirler.vue?vue&type=template&id=7f0b414b&scoped=true&"
import script from "./Demirler.vue?vue&type=script&lang=js&"
export * from "./Demirler.vue?vue&type=script&lang=js&"
import style0 from "./Demirler.vue?vue&type=style&index=0&id=7f0b414b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0b414b",
  null
  
)

export default component.exports